export default __webpack_public_path__ + "static/media/times.97b3c905.svg";